<template>
  <container-wrapper :designer="designer" :widget="widget" :parent-widget="parentWidget" :parent-list="parentList"
    :index-of-parent-list="indexOfParentList">
    <el-card :key="widget.id" class="card-container" @click.native.stop="selectWidget(widget)"
      :shadow="widget.options.shadow" :style="{ width: widget.options.cardWidth + '!important' || '' }" :class="[
        selected ? 'selected' : '',
        !!widget.options.folded ? 'folded' : '',
        customClass,
      ]">
      <div slot="header" class="clear-fix">
        <span class="prefix-filling" />
        <span class="card-title">{{ widget.options.label }}</span>

        <div v-if="widget.options.cardTopButton || widget.options.isShowCheckBox" class="header-slot">
          <span class="checkbox" v-if="widget.options.isShowCheckBox">
            <el-checkbox v-model="isCheck" @change="checkBoxChangeFun()">填写</el-checkbox>
          </span>
          <template v-for="(item, index) in widget.options.cardTopButton">
            <div :class="['card-btn ', item.btnClass]" @click.stop="clickFun(index)">
              {{ item.name }}
              <i v-if="item.btnClass == 'beizhu-btn'" class="el-icon-arrow-down" />
            </div>
          </template>
          <!-- <div class="card_radio" v-if="showRadio">
            <el-radio v-model="radio" label="1" @input="handleRadio(false)">展开</el-radio>
            <el-radio v-model="radio" label="2" @input="handleRadio(false)">收起</el-radio>
          </div> -->
        </div>
        <!-- <div v-if="widget.options.slotName" class="header-slot"> 
            <slot :name="widget.options.slotName"></slot> 
          </div> -->

        <i v-if="widget.options.showFold" class="float-right" :class="[
          !widget.options.folded ? 'el-icon-arrow-down' : 'el-icon-arrow-up',
        ]"></i>
      </div>
      <draggable :list="widget.widgetList" v-bind="{ group: 'dragGroup', ghostClass: 'ghost', animation: 200 }"
        handle=".drag-handler" @add="(evt) => onContainerDragAdd(evt, widget.widgetList)" @update="onContainerDragUpdate"
        :move="checkContainerMove">
        <transition-group name="fade" tag="div" class="form-widget-list">
          <template v-for="(subWidget, swIdx) in widget.widgetList">
            <template v-if="'container' === subWidget.category">
              <component :is="subWidget.type + '-widget'" :widget="subWidget" :designer="designer" :key="subWidget.id"
                :parent-list="widget.widgetList" :index-of-parent-list="swIdx" :parent-widget="widget"></component>
            </template>
            <template v-else>
              <component :is="subWidget.type + '-widget'" :field="subWidget" :designer="designer" :key="subWidget.id"
                :parent-list="widget.widgetList" :index-of-parent-list="swIdx" :parent-widget="widget"
                :design-state="true"></component>
            </template>
          </template>
        </transition-group>
      </draggable>
    </el-card>
  </container-wrapper>
</template>

<script>
import i18n from "@/utils/i18n";
import containerMixin from "@/components/form-designer/form-widget/container-widget/containerMixin";
import Draggable from "vuedraggable";
import ContainerWrapper from "@/components/form-designer/form-widget/container-widget/container-wrapper";
import FieldComponents from "@/components/form-designer/form-widget/field-widget/index";
import refMixinDesign from "@/components/form-designer/refMixinDesign";

export default {
  name: "card-widget",
  componentName: "ContainerWidget",
  mixins: [i18n, containerMixin, refMixinDesign],
  inject: ["refList"],
  components: {
    Draggable,
    ContainerWrapper,
    ...FieldComponents,
  },
  props: {
    widget: Object,
    parentWidget: Object,
    parentList: Array,
    indexOfParentList: Number,
    designer: Object,
  },
  data() {
    return {
      isCheck: false,
      showRadio: false,
      radio:'2'
    };
  },
  computed: {
    selected() {
      return this.widget.id === this.designer.selectedId;
    },

    customClass() {
      return this.widget.options.customClass || "";
    },
  },
  created() {
    this.initRefList();
    // this.showRadio=this.widget.options.folded
  },
  methods: {
    /**
     * 检查接收哪些组件拖放，如不接受某些组件拖放，则根据组件类型判断后返回false
     * @param evt
     * @returns {boolean}
     */
    checkContainerMove(evt) {
      return true;
    },
    handleRadio(type){
      if(type){
        this.radio = this.widget.options.folded?'1':'2'
      }else{
        this.widget.options.folded = !this.widget.options.folded;
      }
    },
    toggleCard() {
      if(!this.widget.options.showFold) return
      this.widget.options.folded = !this.widget.options.folded;
      this.handleRadio(true)
    },

    /**
     * 设置折叠/打开状态
     * @param folded
     */
    setFolded(folded) {
      this.widget.options.folded = !!folded;
    },

    clickFun(index) {
      let tmpFunc = new Function(
        "val",
        this.widget.options.cardTopButton[index].clickFunc
      );
      return tmpFunc.call(this, tmpFunc);
    },

    checkBoxChangeFun() {
      let tmpFunc = new Function("val", this.widget.options.checkBoxChange);
      return tmpFunc.call(this, this.isCheck);
    },
    setCheckBox(value) {
      this.isCheck = value
      this.checkBoxChangeFun()
    },
    getCheckBoxValue() {
      return this.isCheck
    }
  },
};
</script>

<style lang="scss" scoped>
.card-container.selected {
  outline: 2px solid $--color-primary !important;
}

.card-container {
  margin: 0px;

  .form-widget-list {
    min-height: 28px;
  }
}

::v-deep .el-card__header {
  padding: 10px 12px;
  background: #f7f8f9;
}

.folded ::v-deep .el-card__body {
  display: none;
}

.card-title {
  min-width: 60px;
}

.header-slot {
  position: relative;
  margin-left: 20px;
  height: 24px;
  display: flex;
  align-items: center;
}

.clear-fix {
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
}

.clear-fix:before,
.clear-fix:after {
  display: table;
  content: "";
}

.clear-fix:after {
  clear: both;
}

.float-right {
  position: absolute;
  top: 6px;
  right: 10px;
}

.prefix-filling {
  width: 4px;
  background: #409eff;
  display: inline-block;
  height: 14px;
  line-height: 14px;
  margin-right: 10px;
}

::v-deep .el-card {
  border-radius: 0;
  border: none;
}

::v-deep .el-card__header {
  padding: 0;
  line-height: 24px;
  font-size: 14px;
  font-weight: 600;
  padding-left: 14px;
  position: relative;
  margin: 2px 0 6px;
  cursor: pointer;
  color: #3b3b3b;
  background: var(--main-sec-color);
}

::v-deep .el-card__body {
  padding: 0;
}

::v-deep .el-form-item {}

.title-btn {
  height: 20px;
  line-height: 20px;
  color: #fff;
  box-sizing: border-box;
  padding: 0 12px 0 12px;
  border-radius: 10px;
  cursor: pointer;
  display: inline-block;
  font-weight: normal;
  font-size: var(--main-font-size);
  margin-left: 6px;
  position: relative;
  background-color: var(--person-index-btn);
}

.beizhu-btn {
  font-weight: normal;
  background-color: #fff;
  font-size: 14px;
  width: 60px;
  height: 20px;
  line-height: 20px;
  display: inline-block;
  position: relative;
  margin-left: 10px;
  border-radius: 10px;
  cursor: pointer;
  padding-left: 12px;
  color: var(--main-color);
  box-sizing: border-box;
}

.header-slot:has(span)::before,
.header-slot:has(div)::before {
  content: "";
  position: absolute;
  top: 6px;
  left: -11px;
  border-left: 1px solid #ddd;
  height: 12px;
}
.card_radio ::v-deep .el-radio{
  margin-left: 15px!important;
  margin-right: 0!important;
}
</style>
